import { render, staticRenderFns } from "./GameData.vue?vue&type=template&id=f8669878&scoped=true&"
import script from "./GameData.vue?vue&type=script&lang=js&"
export * from "./GameData.vue?vue&type=script&lang=js&"
import style0 from "./GameData.vue?vue&type=style&index=0&id=f8669878&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8669878",
  null
  
)

export default component.exports